import { CSSProperties } from 'styled-components';

export const STYLES_PIN_BOTTOM: CSSProperties = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 'unset',
  bottom: '40px',
  paddingBottom: 0,
};
